/*###########################################################################
// Hero home
//#########################################################################*/

export default function heroHome() {
  return {
    videoPlaying: false,
    mouse: { x: null, y: null },
    isLarge: false,

    init() {
      const self = this

      this.fullVideo = this.$refs.fullVideo

      this.isLarge = window.matchMedia("(min-width: 1024px)").matches

      const updateMouse = (ev) => {
        if (!this.isLarge) return
        this.mouse.x = ev.clientX
        this.mouse.y = ev.clientY
      }

      window.addEventListener("mousemove", updateMouse)

      const mm = window.matchMedia("(min-width: 1024px)")
      const onChangeMM = (e) => {
        this.isLarge = e.matches
        if (!e.matches) {
          this.mouse.x = null
          this.mouse.y = null
        }
      }
      mm.addEventListener?.("change", onChangeMM)
    },

    toggleVideo() {
      if (!this.fullVideo) return;

      if (this.videoPlaying) {
        this.videoPlaying = false
        try {
          this.fullVideo.pause()
        } catch (e) {

        }
      } else {
        this.videoPlaying = true
        this.fullVideo.play().catch(() => {})
      }
    }
  };
}
